<template>
  <div class="bg-gray">
    <navigation-bar />
    <div class="container-fluid">
      <div class="row" v-if="!store.state.selectedCustomer">
        <div class="col-sm-12">
          <div class="search-bar" style="margin-bottom: 0px">
            <br /><br />
            <div class="row">
              <div class="col-sm-12">
                <img
                  :src="require('@/assets/logo_dark.png')"
                  style="
                    margin-bottom: 20px;
                    height: auto;
                    max-height: 150px;
                    max-width: 100%;
                  "
                  title="Everything Cheer & Dance"
                />
              </div>
            </div>
            <br /><br />

            <div
              class="row"
              style="margin-bottom: 20px"
              v-if="store.state.announcements"
            >
              <h1 style="width: 100%">Announcements</h1>
            </div>
            <div class="row wrapper-box">
              <mini-announcement :announcement="store.state.announcements[0]" />
            </div>

            <div class="row" style="margin-bottom: 20px">
              <h1 style="width: 100%">New Listings
                <i 
                  :class="{
                    fa:true,
                    'fa-chevron-down':!store.state.expandNew,
                    'fa-chevron-up':store.state.expandNew,
                  }" 
                  style="font-size:large;cursor:pointer;"
                  @click="newListingsClick"
                />
              </h1>
            </div>
            <div class="row wrapper-box">
              
              <mini-listing-card
                v-for="listing in store.state.listings"
                :key="listing.id"
                :listing="listing"
              />
            </div>

            <div class="row" style="margin: 20px">
              <div class="col-sm-12">
                <router-link to="/account/listing/create">
                  <button class="btn btn-primary btn-orange">
                    Create a Listing
                  </button>
                </router-link>
              </div>
            </div>

            <div class="row" style="margin-bottom: 20px">
              <h1 style="width: 100%">Browse By Category</h1>

              <div
                class="form-group"
                style="text-align: center; margin: 0 auto"
              >
                <label>Filter</label>

                <div class="input-group mb-3">
                  <input class="form-control" v-model="store.state.filter"/>
                  <div class="input-group-append">
                    <button class="btn btn-blue" @click="filterCats">
                      <i class="white fa fa-search" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div
                class="col-xs-12 col-sm-2"
                style="margin-bottom: 20px"
                v-for="service in services"
                :key="service.id"
              >
                <router-link :to="`/feed/${service.slug}`">
                  <div class="service-card">
                    <img
                      :class="{
                        'blue-overlay': service.icon != 'yoga-mat.png',
                      }"
                      v-if="service.icon"
                      style="margin-top: 20px"
                      :src="getImgUrl(service.icon)"
                      width="30px"
                      height="30px"
                    />
                    <img
                      v-else
                      style="margin-top: 20px"
                      src="@/assets/blank.png"
                      width="30px"
                      height="30px"
                    />
                    <h4
                      style="
                        margin-top: 10px;
                        margin-bottom: 10px;
                        font-size: medium;
                      "
                      class="blue"
                    >
                      {{ service.name }}
                    </h4>
                  </div>
                </router-link>
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from "./nav/NavigationBar";
import Store from "./HomeStore";
import API from "@/API/API";
import DashboardFooter from "./nav/Footer";
import Utils from "../Utils/Utils";
import Navigator from "@/router/navigator";
import AccountSessionUtils from "@/components/account/AccountSessionUtils";
import MiniListingCard from "./MiniListingCard";
import MiniAnnouncement from "./MiniAnnouncement.vue";
export default {
  name: "Home",
  components: {
    NavigationBar,
    DashboardFooter,
    MiniListingCard,
    MiniAnnouncement,
  },
  data() {
    return {
      store: Store,
      api: API,
      nav: Navigator,
      accountUtils: AccountSessionUtils,
    };
  },
  mounted() {
    this.getServices();
    this.getListings();
    this.getAnnouncements();

    this.accountUtils.authorize(
      (userId) => {
        this.store.state.currentUserId = userId;
      },
      () => {}
    );
  },
  computed: {
    services() {
      return this. store.state.services.filter(it => {
        return it.name.toLowerCase().includes(this.store.state.filter.toLowerCase());
      })
    }
  },
  methods: {
    getServices: function () {
      this.store.getServices(
        (data) => {},
        (err) => {
          this.$toasted.show(err, { type: "error", duration: 2500 });
        },
        () => {
          this.nav.goMaintenance(this);
        }
      );
    },
    getListings: function () {
      this.store.getNewListing(
        (data) => {
          this.$forceUpdate();
        },
        (err) => {
          this.$toasted.show(err, { type: "error", duration: 2500 });
        },
        () => {
          this.nav.goMaintenance(this);
        }
      );
    },
    getAnnouncements() {
      this.store.getAnnouncements(
        (data) => {
          this.$forceUpdate();
        },
        (err) => {
          this.$toasted.show(err, { type: "error", duration: 2500 });
        },
        () => {
          this.nav.goMaintenance(this);
        }
      );
    },
    getImgUrl(pic) {
      return require("@/assets/" + pic);
    },
    showService(id) {
      this.nav.goFeed(this, id);
    },
    filterCats() {

    },
    newListingsClick() {
      this.store.state.expandNew = !this.store.state.expandNew
      this.getListings()
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.service-card {
  background: white;
  border-radius: 10px;
  height: 100px;
  overflow: hidden;
}

.orange {
  color: #ff6f5e;
}

.blue {
  color: #192965;
}

.orange-overlay {
  filter: invert(53%) sepia(34%) saturate(887%) hue-rotate(318deg)
    brightness(98%) contrast(109%);
}

.blue-overlay {
  filter: invert(16%) sepia(14%) saturate(6187%) hue-rotate(205deg)
    brightness(92%) contrast(100%);
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue